export default "<lib-order-request-stat [domain]=\"'Resource'\">\n</lib-order-request-stat>"